import { environment } from './environment';

/** Required env vars for production - missing values will log errors */
const REQUIRED_PROD_KEYS: (keyof typeof environment)[] = ['apiUrl', 'apiKey', 'socketUrl', 'WEBSITE_URL', 'WEBSITE_NAME'];

/**
 * Validates environment configuration in production.
 * Logs errors for missing or invalid required values.
 * Call from main.ts before bootstrap.
 */
export function validateEnvironment(): void {
    if (!environment.production) return;

    const missing: string[] = [];
    const invalid: string[] = [];

    for (const key of REQUIRED_PROD_KEYS) {
        const value = environment[key];
        if (value === undefined || value === null) {
            missing.push(key);
        } else if (typeof value === 'string' && value.trim() === '') {
            invalid.push(`${key} (empty string)`);
        }
    }

    if (missing.length > 0) {
        console.error(`[Environment] Missing required config in production: ${missing.join(', ')}`);
    }
    if (invalid.length > 0) {
        console.error(`[Environment] Invalid/empty config in production: ${invalid.join(', ')}`);
    }

    // Warn if apiUrl looks like localhost in production
    const apiUrl = environment.apiUrl as string;
    if (apiUrl && (apiUrl.includes('localhost') || apiUrl.includes('127.0.0.1'))) {
        console.warn('[Environment] apiUrl points to localhost in production build. Verify environment.prod.ts.');
    }
}
